import React, { useState, useEffect } from 'react';
import { tippspielAdminAPI } from '../../services/api';

const formatDate = (value) => {
  if (!value) return '–';
  return new Date(value).toLocaleString('de-DE', {
    day: '2-digit',
    month: '2-digit',
    year: 'numeric',
    hour: '2-digit',
    minute: '2-digit'
  });
};

const TippspielParticipants = () => {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');
  const [search, setSearch] = useState('');

  const load = () => {
    setLoading(true);
    setError('');
    tippspielAdminAPI.getParticipants()
      .then((res) => setData(res.data))
      .catch((err) => setError(err.response?.data?.message || 'Laden fehlgeschlagen'))
      .finally(() => setLoading(false));
  };

  useEffect(() => { load(); }, []);

  if (loading) {
    return <div className="flex justify-center py-12"><span className="loading loading-spinner loading-lg text-wacker" /></div>;
  }
  if (error) return <div className="alert-error-dark">{error}</div>;

  const query = search.trim().toLowerCase();
  const participants = (data?.participants || []).filter((p) => {
    if (!query) return true;
    return p.username?.toLowerCase().includes(query) || p.email?.toLowerCase().includes(query);
  });

  return (
    <div className="space-y-6">
      <div className="flex flex-wrap justify-between items-start gap-3">
        <div>
          <h2 className="section-title"><span>Teilnehmer</span></h2>
          {(data?.projectName || data?.seasonName) && (
            <p className="text-sm text-white/50 mt-1">
              {[data.projectName, data.seasonName].filter(Boolean).join(' · ')}
            </p>
          )}
        </div>
        <button type="button" className="btn-wacker-outline text-sm py-2 px-4" onClick={load}>
          Aktualisieren
        </button>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-3 gap-3">
        <div className="glass-card p-4">
          <p className="text-xs uppercase tracking-wide text-white/45 font-bold">Registriert</p>
          <p className="text-2xl font-bold text-white mt-1">{data?.totalRegistered ?? 0}</p>
        </div>
        <div className="glass-card p-4">
          <p className="text-xs uppercase tracking-wide text-white/45 font-bold">Mit Tipps</p>
          <p className="text-2xl font-bold text-primary-light mt-1">{data?.totalWithTips ?? 0}</p>
        </div>
        <div className="glass-card p-4">
          <p className="text-xs uppercase tracking-wide text-white/45 font-bold">Ohne Tipps</p>
          <p className="text-2xl font-bold text-white/70 mt-1">
            {(data?.totalRegistered ?? 0) - (data?.totalWithTips ?? 0)}
          </p>
        </div>
      </div>

      <div>
        <input
          type="search"
          className="input-dark max-w-md"
          placeholder="Suche nach Benutzername oder E-Mail…"
          value={search}
          onChange={(e) => setSearch(e.target.value)}
        />
      </div>

      <div className="overflow-x-auto glass-card">
        <table className="table w-full">
          <thead>
            <tr>
              <th>#</th>
              <th>Benutzername</th>
              <th>E-Mail</th>
              <th>Tipps</th>
              <th>Punkte</th>
              <th>Registriert</th>
              <th>Letzter Tipp</th>
            </tr>
          </thead>
          <tbody>
            {participants.map((p, index) => (
              <tr key={p.userId}>
                <td className="text-white/40">{index + 1}</td>
                <td>
                  <span className="font-medium">{p.username}</span>
                  {p.isAdmin && (
                    <span className="ml-2 text-[0.65rem] uppercase tracking-wide text-amber-300/90 font-bold">
                      Admin
                    </span>
                  )}
                </td>
                <td className="text-sm text-white/70">{p.email}</td>
                <td>
                  <span className={p.tipsCount > 0 ? 'text-primary-light font-bold' : 'text-white/40'}>
                    {p.tipsCount}
                  </span>
                </td>
                <td className="text-sm text-white/70">{p.totalPoints}</td>
                <td className="text-sm text-white/60">{formatDate(p.registeredAt)}</td>
                <td className="text-sm text-white/60">{formatDate(p.lastTipAt)}</td>
              </tr>
            ))}
            {participants.length === 0 && (
              <tr>
                <td colSpan={7} className="text-center text-white/50 py-8">
                  {query ? 'Keine Treffer für diese Suche.' : 'Noch keine Teilnehmer registriert.'}
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default TippspielParticipants;
